import React, { useState, useEffect } from 'react'
import "./index.scss"
import Userbox from './Userbox'
import {Menu} from 'antd'
import { useNavigate } from "react-router-dom"
import logoImage from '../../assets/logo.png';
import { router } from 'router'
import _ from 'lodash'
import {getSpaceUrl} from 'utils/api'

import { useTranslation } from "react-i18next";

import { getItem } from 'utils/tokenStore'

const Header = () => {
  const { t, i18n } = useTranslation();
  const [ menuItems, updateMenuItems ] = useState([])
  const [ isAdmin, setIsAdmin] = useState(false)

  const imageUrl = getSpaceUrl() + "logo.png"

  const navigate = useNavigate()

  const [imageExists, setImageExists] = React.useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = imageUrl;
    img.onload = () => {
      setImageExists(true);
    };
    img.onerror = () => {
      setImageExists(false);
    };
  }, [imageUrl]);

  useEffect(()=>{
    const dashboard = _.find(router, { label: "Dashboard" })?.children || [];

    let items;
    if (getItem("LOGIN_TOKEN") && getItem("TYPE")) {
      console.log("User type:", getItem("TYPE"));
      if (getItem("TYPE") === "1") {
        items = dashboard.slice(0, 3);
      }
      else if (getItem("TYPE") === "2") {
        items = dashboard.slice(0, 4);
      } 
      else {
        items = dashboard.slice(0, 1);
      }
    } else {
      items = dashboard.slice(0, 1);
    }

    // 🔥 Translate here
    const translatedItems = items.map(item => ({
      key: item.key,
      path: item.path,
      element: item.element,
      label: t(item.label), // use translation key if defined
    }));

    updateMenuItems(translatedItems);
  },[])

  const navigateTo = (item) => {
    navigate('/dashboard/' + item.key)
    document.title = "Gaitmetrics - " + (_.find( menuItems, { key: item.key } )).label
  }

  const getSelectedKey = (isOpenKey) => {
    let tmp = window.location.pathname.split("/")
    let tmpIndex = tmp.indexOf("dashboard")
    if( tmpIndex > -1 ){
      tmp.splice( 0, tmpIndex + 1)
    } else {
      return []
    }
    if( isOpenKey ){
      return tmp.slice(0, -1)
    } else {
      return tmp.slice(-1)
    }
  }

  return(
    <div className='header-container'>
      <div style={{ display: 'flex', alignItems: 'center', width:'100%' }}>
        <div style={{ marginRight: '16px', width: '10rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={logoImage}
              alt="Logo"
              style={{
                height: '100%',
                width: imageExists ? '5rem' : '10rem',
              }}
            />
            {imageExists && (
              <img
                src={imageUrl}
                alt="Some description"
                style={{ maxHeight: '3rem', height:'auto', width: '3rem',marginLeft: '5px' }}
              />
            )}
          </div>
        </div>
        <Menu 
          style={{width:'100%'}}
          theme="light" 
          mode="horizontal"
          onClick={navigateTo}
          selectedKeys={getSelectedKey()}
          defaultSelectedKeys={['home']}
          items={menuItems}
        >
        </Menu>
      </div>
      <div>
        <span 
          style={{ cursor: "pointer", marginRight: "10px" }} 
          onClick={() => {
          i18n.changeLanguage("en")
          window.location.reload()
          }}
        >
          English
        </span>

        <span 
          style={{ cursor: "pointer" }} 
          onClick={() => {
          i18n.changeLanguage("jp")
          window.location.reload()
          }}
        >
          日本語
        </span>
      </div>

      <div>
        <Userbox/>
      </div>
    </div>
  )
}

export default Header